<!-- 
Listing of notice templates.
-->
<template>
  <div>
    <v-card :class="embedded ? 'v-card--flat' : ''">
      <our-simple-table-header
        :total-items="listing.paging.totalItems"
        :has-export-to-json="hasExport"
        :has-export="hasExport"
        @click:refresh="refresh"
        @click:clearCriteria="clearCriteria"
        @click:export="exportToExcel"
        @click:exportToJson="exportToJson"
      />
      <our-table-busy-indicator :show="listing.loading"/>
      <v-data-table
        :headers="headers" 
        :items="listing.data" 
        :pagination="listing.paging" 
        :total-items="listing.paging.totalItems"
        :no-data-text="noDataText"
        class="notice-template-listing"
        must-sort
        hide-actions
        @update:pagination="updatePagination"
      >
        <template slot="items" slot-scope="props">
          <tr @click.stop="rowSelected(props.item.type, props.item)">
            <our-nav-col :row="`${props.item.id}`"/>
            <td>{{ lookups.noticeTypeDescriptions[props.item.type] }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import tableMixins from "@/mixins/table.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import * as action from "@/store/notice-templates/action-types";
import * as mutation from "@/store/notice-templates/mutation-types";
import { NOTICE_TEMPLATES_EXPORT } from "@/store/claim-types";

export default {
  mixins: [tableMixins, lookupMixins, filterMixins],
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      action: action.LIST,
      exportAction: action.EXPORT_SPREADSHEET,
      exportToJsonAction: action.EXPORT_JSON,
      pagingMutation: mutation.LIST_SET_PAGING,
      headers: [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "Type", value: "Type", sortable: true }
      ]
    };
  },
  computed: {
    state() {
      return this.$store.state.noticeTemplates;
    },
    listing() {
      return this.state.listing;
    },
    loaded() {
      return this.listing.loaded;
    },
    testingToolsEnabled() {
      return this.$store.getters.testingToolsEnabled;
    },
    hasExport() {
      return this.$store.getters.claims.includes(NOTICE_TEMPLATES_EXPORT);
    }
  },
  watch: {
    levyCollectionId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      if ((!this.listing.loaded && !this.listing.loading) || this.state.levyCollectionId != this.levyCollectionId) {
        this.$store.commit(mutation.LIST_SET_FILTERS, { levyCollectionId: this.levyCollectionId });
        this.populate();
      }
    }
  }
};
</script>
